/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {Contracts} from '../../core/_models'

type Props = {
  Contracts: Contracts
}

const ContractsTypes: FC<Props> = ({Contracts}) => {
  const intl = useIntl()

  return (
    <div className='d-flex text-center justify-content-center'>
      <div className='d-flex flex-column'>
        <a
          href='#'
          className='text-gray-800 fw-semibold fs-7 mb-1'
          style={{
            maxWidth: '12ch',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {Contracts.contract_type === 'production' &&
            intl.formatMessage({id: 'CONTRACTS.TYPE_PRODUCTION'})}
          {Contracts.contract_type === 'servitude' &&
            intl.formatMessage({id: 'CONTRACTS.TYPE_SERVITUDE'})}
          {Contracts.contract_type === 'direct_damage' &&
            intl.formatMessage({id: 'CONTRACTS.TYPE_DIRECT_DAMAGE'})}
          {Contracts.contract_type === 'not_specified' &&
            intl.formatMessage({id: 'CONTRACTS.NOT_SPECIFIED'})}
        </a>
      </div>
    </div>
  )
}

export {ContractsTypes}
